import dragonballIcon from "@/assets/images/dragonball-icon.png";
import sparrowIcon from "@/assets/images/sparrow-icon.png";

export function ToolIcon({
  type,
  className = "h-6 w-6",
}: {
  type: "dragonball" | "sparrow";
  className?: string;
}) {
  const src = type === "dragonball" ? dragonballIcon : sparrowIcon;
  const alt = type === "dragonball" ? "DragonBall" : "Sparrow";
  return (
    <span className="inline-flex items-center gap-1">
      <img
        src={src}
        alt={alt}
        className={`object-contain rounded-sm ${className}`}
        data-testid={`icon-tool-${type}`}
      />
    </span>
  );
}
